import { Route } from "vue-router";
import IRouteMiddleware from "./IRouteMiddleware";

export default class DocumentTitleMiddleware implements IRouteMiddleware {  
  hookCallTime: "before" | "after" = 'after';
  async process(context: {to: Route, from: Route, next?: Function}) {
    document.title = context.to.meta.title || 'DEFAULT_TITLE';
    context.next && context.next();
  }
}